<template>
  <div class="password">
    <md-field class="user-form">
      <div class="form-group">
        <div class="form-label">{{ $t('recentPassword') }}</div>
        <md-input-item
          class="bordered"
          type="password"
          ref="oldPassword"
          name="oldPassword"
          v-model="passForm.oldPassword"
          v-validate="'required'"
          :error="errors.first('oldPassword')"
        ></md-input-item>
      </div>
      <div class="form-group">
        <div class="form-label">{{ $t('newPassword') }}</div>
        <md-input-item
          class="bordered"
          type="password"
          ref="newPassword1"
          name="newPassword1"
          v-model="passForm.newPassword1"
          v-validate="'required'"
          :error="errors.first('newPassword1')"
        ></md-input-item>
      </div>
      <div class="form-group">
        <div class="form-label">{{ $t('confirmPassword') }}</div>
        <md-input-item
          class="bordered"
          ref="newPassword2"
          name="newPassword2"
          type="password"
          v-model="passForm.newPassword2"
          v-validate="'required|confirmed:newPassword1'"
          :error="errors.first('newPassword2')"
        ></md-input-item>
      </div>
    </md-field>
    <div class="submit-button">
      <md-button type="primary" round @click="changePassword">
        {{ $t('save') }}
      </md-button>
    </div>
  </div>
</template>

<script>
import { Field, InputItem, Button } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        confirmPassword: 'Confirm Password',
        newPassword: 'New Password',
        passwordNotTheSame: 'Password does not match',
        recentPassword: 'Current Password',
        save: 'Save',
      },
      id: {
        confirmPassword: 'Kata sandi konfirmasi',
        newPassword: 'Password baru',
        passwordNotTheSame: 'Password baru yang Anda isi berbeda*',
        recentPassword: 'Kata sandi Saat Ini',
        save: 'Simpan',
      },
    },
  },
  components: {
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
  },
  data() {
    return {
      passForm: {
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
      },
    }
  },
  methods: {
    async changePassword() {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          const payload = {
            oldPassword: this.passForm.oldPassword,
            newPassword: this.passForm.newPassword1,
          }
          this.$toast.loading('loading...')
          await this.$http.post('/auth/change-password', payload)
          await this.$store.dispatch('logout')
          this.$router.push('/login')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$toast.hide()
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.password {
  padding: 30px 0;
}
.form-group {
  margin-bottom: 20px;
  .form-label {
    margin-bottom: 8px;
    color: #555;
    font-size: 12px;
  }
}

.submit-button {
  padding: 15px;
}
</style>
